<script lang="ts" setup>
import { Prop } from 'vue'
import { defineRule, Field as VeeField } from 'vee-validate'
// components
import BasketGiftsList from '~/components/Basket/basket-gifts/BasketGiftsList.vue'
import BasketGiftsInfo from '~/components/Basket/basket-gifts/BasketGiftsInfo.vue'
import BasketGiftsToggle from '~/components/Basket/basket-gifts/BasketGiftsToggle.vue'
import BasketTitle from '~/components/Basket/basket-utils/BasketTitle.vue'
// store
import { useBasketStore } from '~/store/basket/basket'
// utils
import { notActiveGift } from '@/utils/rulesOfValidate'
// types
import { Gift } from '~/types/api/api-v3/basket'
import { SelectedGift } from '~/types/store/basket'

const NOT_ACTIVE_GIFT = 'notActiveGift'

const basketStore = useBasketStore()

const props = defineProps({
  gifts: {
    type: Array,
    required: true,
  } as Prop<Gift[]>,
  isGiftNeed: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:is-gift-need'])

const selectedGift = computed(() => basketStore.data.selectedGifts[0])

const rule = computed(() => (props.isGiftNeed ? NOT_ACTIVE_GIFT : ''))

const onSelectGift = (selectedGift: SelectedGift) =>
  basketStore.setSelectedGift(selectedGift)

const updateModelValue = (value: boolean) => emit('update:is-gift-need', value)

defineRule(NOT_ACTIVE_GIFT, notActiveGift)
</script>

<template>
  <section id="gifts" class="gifts">
    <basket-title title="Подарки" />

    <vee-field
      v-slot="{ errors }"
      name="gifts"
      vid="gifts"
      :rules="rule"
      :model-value="selectedGift"
    >
      <basket-gifts-list
        v-for="gift in gifts"
        :key="gift.rule_id"
        :products="gift.products"
        :rule-id="gift.rule_id"
        :is-gift-need="isGiftNeed"
        :selected-gift="selectedGift"
        @select-gift="onSelectGift"
      />

      <basket-gifts-info :errors="errors" />
    </vee-field>

    <hr class="gifts__line" />

    <basket-gifts-toggle
      :is-gift-need="isGiftNeed"
      @update:model-value="updateModelValue"
    />
  </section>
</template>

<style lang="scss" scoped>
.gifts {
  overflow: hidden;
}

.gifts__line {
  margin: 20px;
  border: 1px solid $button-background;

  @include media('<tablet') {
    margin: 16px 0 20px;
  }
}
</style>
